import { render, staticRenderFns } from "./PayoutMethod.vue?vue&type=template&id=3b7e0cda&scoped=true&"
import script from "./PayoutMethod.vue?vue&type=script&lang=js&"
export * from "./PayoutMethod.vue?vue&type=script&lang=js&"
import style0 from "./PayoutMethod.vue?vue&type=style&index=0&id=3b7e0cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7e0cda",
  null
  
)

export default component.exports